<template>
  <div>
    <div class="clearfix"></div>
    <div class="row" v-if="fileId">
      <div class="col-md-6 col-sm-6 col-xs-12">
        <div class="card">
          <div class="card-header">
            <h3>File details</h3>
              <h3 v-if="fileData.status == 'completed'" class="text-success pull-right"><i class="fas fa-check-circle"></i> COMPLETED</h3>
              <h3 v-if="fileData.status == 'pending'" class="text-pending pull-right"><i class="fas fa-clock"></i> PENDING</h3>
              <h3 v-if="fileData.status == 'canceled'" class="text-error pull-right"><i class="fas fa-times"></i> CANCELED</h3>
              <div class="clearfix"></div>
          </div>
          <div class="card-content">
            <table class="table table-hover">
              </thead>
              <tbody>
                <tr>
                  <th scope="row">File ID</th>
                  <td>{{ fileData.id }}</td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">Upload date and time</th>
                  <td>{{ fileData.created_at }}</td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">Type</th>
                  <td>{{ fileData.type }}</td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">Status</th>
                  <td>
                    <nobr>
                    <span v-if="fileData.status == 'completed'" class="text-success"><i class="fas fa-check-circle"></i></span> 
                    <span v-if="fileData.status == 'pending'" class="text-pending"><i class="fas fa-clock"></i></span> 
                    <span v-if="fileData.status == 'canceled'" class="text-error"><i class="fas fa-times"></i></span> 
                    &nbsp; {{ fileData.status }}
                    </nobr>
                </td>
                  <td></td>
                </tr>
                <tr class="column-title">
                  <td colspan="3" class="text-center">Files uploaded by customer</td>
                </tr>
                <tr v-for="(file, key) in fileData.files">
                  <th scope="row">File {{ parseInt(key + 1) }}</th>
                  <td>{{ file.name }}</td>
                  <td><a @click="downloadFile(fileData.id, file.name)" href="#" class="btn btn-primary"><i class="fas fa-download fa-lg"></i></a></td>
                </tr>
                <tr>
                  <td colspan="3">
                    <a @click="downloadFile(fileData.id)" class="btn btn-primary btn-block"><i class="fas fa-file-archive"></i> download all as zip</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h3>Upload</h3>
            <h3 v-if="this.fileData" class="text-pending pull-right"><i class="fas fa-cog-o"></i> {{ this.fileData.product.short_name }}</h3>
            <div class="clearfix"></div>
          </div>
          <div class="card-content">
            <vue-dropzone ref="uploadZone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-success-multiple="uploadSuccess" style="font-family: 'Roboto', Arial, Verdana; "></vue-dropzone>
          </div>
          <form name="fileUploadForm" novalidate class="form-horizontal">
            <table class="table table-hover">
              <tbody>
                <tr v-if="this.fileData.product">
                  <th scope="row">Requested tuning type</th>
                  <td><strong>{{ this.fileData.product.short_name }}</strong></td>
                </tr>
                <tr>
                  <th scope="row">Customer message</th>
                  <td>{{ this.fileData.customer_notes }}</td>
                </tr>
              </tbody>
            </table>
            <div class="form-group" :class="{'text-error': errors.has('uploadMessage') }">
              <label class="control-label col-md-3 col-sm-3 col-xs-12">Add an upload message for this customer?</label>
              <div class="col-md-9 col-sm-9 col-xs-12">
                <textarea v-model="processData.message" name="uploadMessage" class="form-control" rows="3" placeholder="Upload message for customer" v-validate="'required'"></textarea>
              </div>
            </div>
            <div class="form-group" :class="{'text-error': errors.has('uploadCredits') }">
              <label class="control-label col-md-3 col-sm-3 col-xs-12">Credits to take from customer?</label>
              <div class="col-md-9 col-sm-9 col-xs-12">
                <input v-model="processData.credits" name="uploadCredits" type="number" class="form-control" placeholder="0" v-validate="'required|numeric'">
              </div>
            </div>
            <div class="form-group" :class="{'text-error': errors.has('uploadCredits') }">
              <label class="control-label col-md-3 col-sm-3 col-xs-12">Current credits balance</label>
              <div class="col-md-9 col-sm-9 col-xs-12">
                <label :class="{'text-error': customerData.credits < 10}" class="control-label">{{ customerData.credits }}</label>
              </div>
            </div>
            <div class="ln_solid"></div>
            <div class="form-group">
              <button type="button" @click="goBack()" class="btn"><i class="fas fa-arrow-alt-circle-left"></i> Go back</button>
              <button type="button" @click="process()" id="submitButton" class="btn btn-success pull-right" disabled data-tooltip="Upload some files first"><i class="fa" :class="{'fa-upload': !uploadingFile, 'fa-circle-o-notch fa-spin fa-fw': uploadingFile}" :disabled="uploadingFile" aria-hidden="true"></i> Upload file</button>
            </div>
          </form>
        </div>
      </div>

      <div class="col-md-6 col-sm-6 col-xs-12">
        <div class="card">
          <div class="card-header">
            <h3>Customer details</h3>
            <div class="clearfix"></div>
          </div>
          <div class="card-content">
            <div class="col-md-12 col-sm-12 col-xs-12">
              <table class="table table-hover">
                <tbody>
                  <tr>
                    <th scope="row">Customer name & Credits</th>
                    <td>{{ customerData.last_name }}, {{ customerData.first_name }}</td>
                    <td>{{ customerData.credits }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Registered on</th>
                    <td>{{ customerData.created_at }}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <th scope="row">Address</th>
                    <td>{{ customerData.address_1 }}</td>
                    <td>{{ customerData.address_2 }}</td>
                  </tr>
                  <tr>
                    <th scope="row">ZIP & Country</th>
                    <td>{{ customerData.zipcode }}</td>
                    <td>{{ customerData.country }}</td>
                  </tr>
                  <tr v-if="customerData.deleted_at" class="text-error ">
                    <th scope="row">Status</th>
                    <td><span class="label label-danger"><i class="fas fa-trash-alt"></i> DELETED</span></td>
                    <td>{{ customerData.deleted_at }}</td>
                  </tr>
                  <tr class="column-title">
                    <td>Total bought</td>
                    <td>Currently</td>
                    <td>Total spent</td>
                  </tr>
                  <tr>
                    <td>{{ customerData.credits_total_number }}</td>
                    <td>{{ customerData.credits }}</td>
                    <td>{{ customerData.credits_total_spent }}</td>
                  </tr>
                  <tr></tr>
                  <tr class="column-title">
                    <td>Total uploaded</td>
                    <td>Total completed</td>
                    <td>Total canceled</td>
                  </tr>
                  <tr>
                    <td>{{ customerData.credits_total_number }}</td>
                    <td>{{ customerData.credits }}</td>
                    <td>{{ customerData.credits_total_spent }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h3>Vehicle & Tuning information</h3>
            <div class="clearfix"></div>
          </div>
          <div class="card-content">
            <div class="col-md-12 col-sm-12 col-xs-12">
              <table class="table table-hover">
                <tbody>
                  <tr v-if="productData">
                    <th scope="row">Tuning type & Credits</th>
                    <td>{{ productData.short_name }}</td>
                    <td>{{ productData.credits }}</td>
                  </tr>
                  <tr v-if="fileData.brand">
                    <th scope="row">Brand & Serie</th>
                    <td>{{ fileData.brand.name }}</td>
                    <td>{{ fileData.series.name }}</td>
                  </tr>
                  <tr v-if="fileData.build">
                    <th scope="row">Build & Year</th>
                    <td>{{ fileData.build.name }}</td>
                    <td>{{ fileData.build.name }}</td>
                  </tr>
                  <tr v-if="fileData.details.ecudetails">
                    <th scope="row">ECU Details</th>
                    <td>{{ fileData.details.ecudetails.brand }}</td>
                    <td>{{ fileData.details.ecudetails.model }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h3>Related tickets</h3>
            <div class="clearfix"></div>
          </div>
          <div class="card-content">
            <div v-if="fileData.tickets">
            <ul class="list-unstyled timeline widget">
              <v-server-table :url="tblTicketsUrl" :columns="tblTicketsColumns" :options="tblTicketsOptions" ref="ticketTable" v-if="tblTicketsUrl">
                <template slot="created_by" slot-scope="props">
                  <div v-if="!props.row.user_id">by customer</div>
                  <div v-else>by engineer {{ props.row.user_id }}</div>
                </template>
                <template slot="user_status" slot-scope="props">
                  <span @click="setTicketMessageRead(props.row.id)" v-if="props.row.user_status == 'unread'" class="unreadIcon pull-right" data-tooltip="Set this message as 'read'"><i class="fas fa-star fa-lg"></i></span>
                </template>
                <template slot="child_row" slot-scope="props">
                  Message: {{props.row.message}}<br/><br/>
                  <a class="btn btn-sm btn-primary" @click="readTicketmessage(props.row.message)"><i class="fas fa-arrow-alt-circle-right"></i> Read&nbsp;More</a>
                </template>                
                </v-server-table>
            </ul>
          </div>
          <div v-else>
            <h5>No tickets</h5>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <h4>Please load a file from the overview to show the details here</h4>
    </div>
  </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
export default {
  props: ["fileId"],
  components: {
    vueDropzone: vue2Dropzone
  },
  data: function() {
    return {
      uploadingFile: false,
      fileData: '',
      customerData: '',
      productData: '',
      processData: {message: '', credits: '', files: ''},
      columns: ['fuel_type', 'name', 'slug', 'hp', 'kw', 'actions'],
      dropzoneOptions: {
        paramName: 'files',
        url: '/fileservice/' + this.$route.params.id + '/upload',
        maxNumberOfFiles: 5,
        uploadMultiple: true,
        parallelUploads: 3,
        thumbnailWidth: 100,
        maxFilesize: 25,
        timeout: 180000,
        dictDefaultMessage: "<h1><i class='fa fa-cloud-upload-alt fa-5x'></i></h1><br/><h3>upload your file(s) here...</h3>"
      },
      tblTicketsOptions: {
        childRow: function(h, row) {
          return row;
        }
      },
      tblTicketsUrl: '',
      tblTicketsColumns: ['created_at', 'subject', 'status', 'created_by']
    }
  },
  mounted: function () {
  },
  methods: {
    goBack() {
      $("html, body").animate({ scrollTop: 0 }, "fast");
      $('.nav-tabs a[href="#overviewTab"]').tab('show');
    },
    loadFileDetails(fileId) {
      this.fileData = ''; this.customerData = ''; this.processData = {message: '', credits: '', files: ''}; 
      $('#submitButton').prop("disabled", true);$('#submitButton').attr("data-tooltip", "Upload files to continue");
      if(this.$refs.uploadZone) { this.$refs.uploadZone.removeAllFiles(); }
      TuningCRM.getFile(fileId).then(response => {
        this.tblTicketsUrl = '/tickets?file_id=' + fileId;
        this.fileData = response.data;
        if(response.data.customer) {
          this.customerData = response.data.customer;
        }
        if(response.data.stage) {
          this.stageData = response.data.stage;
        }
        if(response.data.product) {
          this.productData = response.data.product;
          this.processData.credits = Math.round(response.data.product.credits);
        }
        if(response.data.status === 'completed') {
          toastr.info('This file has the status completed already', 'File completed');
        }else if(response.data.status === 'canceled') {
          toastr.info('This file has the status canceled. You can continue to deliver the file, the status will be set to completed if you have completed the request', 'File canceled');
        }
      })
    },
    downloadFile(fileId, filename) {
      TuningCRM.downloadFile(fileId, filename);
    },
    uploadSuccess(file, response) {
      if(response) {
        this.processData.files = response;
        $('#submitButton').prop("disabled", false);
        $('#submitButton').attr("data-tooltip", "Process upload");
        toastr.success('File(s) uploaded, you can continue now', 'Upload done');
        
      }
    },
    process() {
      this.$validator.validateAll().then((result) => {
        if (result === true) {
          TuningCRM.processUpload(this.fileId, this.processData.credits, this.processData.message, this.processData.files).then(response => {
            toastr.success('Processing completed!', 'Completed'); 
            //activate main tab
            this.$emit('update:loadedFileStatus', 'saved');
            this.$emit('fileSaved');
          }).catch(function (error) {
            toastr.error('Something went wrong during the process. Please retry or contact your account manager.', 'Bummer...');
          });
        } else {
          toastr.warning('Not all fields have been entered correctly. Please fix this and retry.', 'Validation failed');
        }
      });
    },
    readTicketmessage(ticketId) {
      this.$router.push({name: 'tickets', params: {ticketId: ticketId}});
    },
    setTicketMessageRead(id) {
      TuningCRM.setTicketMessageRead(id).then(response => {
        if(response) {
          toastr.success('Ticket status set to read', 'Ticket updated'); 
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/components/file.vue